import { render, staticRenderFns } from "./updatesDialog.vue?vue&type=template&id=47128cfe&"
import script from "./updatesDialog.vue?vue&type=script&lang=js&"
export * from "./updatesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports